import { InfiniteScroll } from '@portalCommon/components';
import { SUCCESS_CASES, ComponentProps } from '@portalCommon/constants/';
import classnames from 'classnames/bind';
import { OptimizedImg } from '@commonPackage/components';
import { ModuleTitle } from '../../styles';
import styles from './index.module.less';

const cx = classnames.bind(styles);

export const SuccessCases = ({ type, title, subtitle }: ComponentProps) => {
  const list = SUCCESS_CASES[type];
  return (
    <div className={cx('success-cases-container')}>
      <ModuleTitle marginBottom={18}>{title[0]}</ModuleTitle>
      <div className={cx('subtitle')}>{subtitle}</div>
      <InfiniteScroll
        ifHoverPaused
        wrapperStyle={{ height: 590, marginTop: 20 }}
        itemSize={{ width: 460, gap: 48 }}
        listCounts={list.length}
        speed={45}>
        {[...list, ...list].map((item, idx) => (
          <div className={cx('card-item')} key={item.cover + idx}>
            <OptimizedImg className={cx('image')} src={item.cover} loading="lazy" width={459} />
            <div className={cx('tags')}>
              {item?.tags?.map((tag: string) => (
                <span className={cx('tag-item')} key={tag}>
                  {tag}
                </span>
              ))}
            </div>
            <div className={cx('title')}>{item.title}</div>
            <div className={`${cx('brief')} ${cx('title')}`}>{item.brief}</div>
          </div>
        ))}
      </InfiniteScroll>
    </div>
  );
};
